// @flow
import styled from 'styled-components';
import { PlayerRowMenuButton } from '../';


export const TradeButton = styled(PlayerRowMenuButton)`
	width: 40px;
	height: 40px;
`;

export default TradeButton;


// WEBPACK FOOTER //
// ./src/components/PlayersTable/tradeButton.js